// extracted by mini-css-extract-plugin
module.exports = {"defaultColumnWidth":"150px"};